import axios from 'axios'
import { ACCOUNT_URL } from 'common/constants/env'
import pkg from '../../../package.json'
import { onResponseSuccess, setApiHeaders } from './interceptors'

const packageVersion = pkg.version

const accountApi = axios.create({
  baseURL: ACCOUNT_URL,
})

accountApi.interceptors.request.use(setApiHeaders)
accountApi.interceptors.response.use(onResponseSuccess)

accountApi.defaults.headers.common.Accept = 'application/json'
accountApi.defaults.headers.common['Content-Type'] = 'application/json'
accountApi.defaults.headers.common.credentials = 'include'
accountApi.defaults.headers.common['X-App-Version'] = packageVersion

export default accountApi
